import { Box, useMediaQuery, useTheme } from '@mui/material';
import LogoBlackSrc from '../../../../../../../assets/connect_by_flexeserve_logo_BLK_Color.svg';
import LogoWhiteSrc from '../../../../../../../assets/connect_by_flexeserve_logo_WHT_Color.svg';

function HeaderLogoDev() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logoSrc = theme.palette.mode === 'dark' ? LogoWhiteSrc : LogoBlackSrc;

  return (
    <Box
      component={'img'}
      src={logoSrc}
      alt="yourlogo"
      sx={(theme) => ({
        fontSize: isMobile ? '0.6rem' : undefined,
        height: '2.5rem',
        maxWidth: '150px',
        color: theme.palette.text.primary,
      })}
    />
  );
}

export default HeaderLogoDev;
